import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

// Components
import Timeline from "../../../components/Timeline";

// Data
import timelineElements from "../../../data/timelineElements";

// Style
import { Container } from "react-bootstrap";

const VerticalTimeline = () => {
  gsap.registerPlugin(ScrollTrigger);

  //  Props references
  const textRefs = useRef([]);
  textRefs.current = [];

  const addToTextRefs = (el) => {
    if (el && !textRefs.current.includes(el)) {
      textRefs.current.push(el);
    }
  };

  function calcDelay(index) {
    if (index === 0) return index;
    return index - index * 0.8;
  }

  useEffect(() => {
    textRefs.current.forEach((el, index) => {
      gsap.fromTo(
        el,
        { autoAlpha: 0, y: 50 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          delay: calcDelay(index),
          ease: "power4.out",
          scrollTrigger: {
            id: "projetos",
            trigger: el,
            start: "top center+=100",
          },
        }
      );
    });
  }, []);

  return (
    <div id="timeline" className="block">
      <Container>
        <h2 className="text-center title" ref={addToTextRefs}>
          My Journey 💻
        </h2>
        <h4 className="text-center subtitle mb-4" ref={addToTextRefs}>
          Here you can discover my life path in computer science and some
          curious facts about me.
        </h4>
        <div ref={addToTextRefs}>
          <Timeline elements={timelineElements} />
        </div>
      </Container>
    </div>
  );
};

export default VerticalTimeline;
